import { $ABTest, $RootTraffic, $WebUser } from '@lemon8/web-app-shared/atom';
import { DeepLinkBuildingProps, buildSchema } from './schema';
import { useMemo } from 'react';
import { $PageLevelTraffic } from 'shared/atoms/page-traffic';
import { useAtomValue } from 'jotai';

export type ICompletedActiveSchemaExtraParams = {
  enterPosition: string;
};

export const useCompletedActiveSchema = (
  schemaOption: DeepLinkBuildingProps & { pid: string },
  extraParams?: ICompletedActiveSchemaExtraParams,
): string => {
  const { seoPageId, pageType } = useAtomValue($PageLevelTraffic);
  const { trafficPid } = useAtomValue($RootTraffic);
  const { webId } = useAtomValue($WebUser);
  const { versions } = useAtomValue($ABTest);

  return useMemo(() => {
    const schema = buildSchema({
      ...schemaOption,
      pid: schemaOption.pid || trafficPid,
    });

    const schemaURL = new URL(schema);

    schemaURL.searchParams.set('ab_version', versions);

    schemaURL.searchParams.set(
      'amp_extra',
      JSON.stringify({
        traffic_type: trafficPid,
        enter_page_type: pageType,
        seo_page_id: seoPageId,
        web_id: webId,
        enter_position: extraParams?.enterPosition,
      }),
    );

    return schemaURL.toString();
  }, [versions, schemaOption]);
};
